import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
    titlePrincipal: {
        fontWeight: 600,
        width: '100%',
        paddingLeft: theme.spacing(1),
        // fontSize: 24,
    },
    subTitle: {
        width: '100%',
        paddingLeft: theme.spacing(1),
        // fontSize: 19,
        // marginBottom: '8% !important',
        color: theme.palette.success.main,
    },
    title: {
        marginTop: theme.spacing(1),
        textAlign: 'flex-start !important'
    },
    // subTitle: {
    //     color: theme.palette.success.main,
    //     textAlign: 'flex-start !important'
    // },
    docsSection: {
        width: '100%',
        '@media (max-width: 650px)': {
            width: '95%'
        }
    },
    imageIcon: {
        marginTop: '15% !important',
        width: '50%',
        ['@media only screen and (max-width: 812px)']: {
            marginTop: '10% !important',
            width: '40%',
        },
    },
    containerImage: {
        display: 'grid !important',
        gridTemplateColumns: '100%',
        height: '55vh !important',
        marginTop: 5,
        marginBottom: 5,
        // backgroundColor: theme.palette.background.paper,
        overflowY: 'none',
        ['@media only screen and (max-width: 812px)']: {
            gridTemplateColumns: '100%',
            height: '55vh !important',
        },
        // marginBottom: '5% !important'
    },
    textSection: {
        width: '80%',
        marginLeft: theme.spacing(5),
        marginTop: theme.spacing(2)
    },

    docVisual: {
        height: '67vh',
        width: '100%',
        backgroundColor: theme.palette.secondary.light,
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },

    doc: {
        width: '95%',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
    },

    docLoading: {
        width: '95%',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },

    docs: {
        width: '100%',
        height: '67vh',
        overflowY: 'auto',
        marginTop: theme.spacing(1)
    },

    mobileDoc: {
        display: 'flex !important',
        flexDirection: 'column !important',
        alignItems: 'center !important',
        width: '100% !important',
        height: '65vh !important',
        overflowY: 'auto !important',
    },

    buttonSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    button: {
        '&:focus': {
            outline: 'none !important',
        },
    },

    button2: {
        '&:focus': {
            outline: 'none !important',
        },
    },

    visorContentPrinc: {
        border: '1px solid #A0A1A2',
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'center',
        height: '100%',
        width: '100%',
    },
    pdfContentCenter: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        textAlign: 'center',
    }
}))